export const adminEn = {
  'admin.common.retry': 'Try again',
  'admin.common.refresh': 'Refresh',
  'admin.common.refreshing': 'Refreshing…',
  'admin.common.search': 'Search',
  'admin.common.status': 'Status',
  'admin.common.name': 'Name',
  'admin.common.unknown': 'Unknown',
  'admin.common.anonymous': 'Anonymous',
  'admin.common.cancel': 'Cancel',
  'admin.common.enabled': 'Enabled',
  'admin.common.disabled': 'Disabled',
  'admin.common.active': 'Active',
  'admin.common.other': 'Other',
  'admin.preview.title': 'Viewing the site as a {type} account',
  'admin.preview.body': 'UI preview only. Your admin identity and server permissions are unchanged.',
  'admin.preview.exit': 'Exit preview',
  'admin.release.title': 'Release notes',
  'admin.release.description': 'A history of production releases and the changes included in each one.',
  'admin.release.loading': 'Loading release notes',
  'admin.release.loadError': 'Could not load release notes.',
  'admin.release.empty': 'No releases have been recorded yet.',
  'admin.release.release': 'Release {version}',
  'admin.release.commits': '{count} commit | {count} commits',
  'admin.release.loadingOne': 'Loading release',
  'admin.release.loadOneError': 'Could not load this release.',
  'admin.release.changesSince': 'Changes since release {version}',
  'admin.release.initialBaseline': 'Changes since the initial release baseline',
  'admin.release.summary': 'Summary',
  'admin.release.fullCommits': 'Full commit messages ({count})',
  'admin.release.noCommit': 'This release did not include a new source commit.',
  'admin.diagnostics.title': 'Diagnostics',
  'admin.diagnostics.description': 'Redacted browser diagnostics and PocketBase database errors.',
  'admin.diagnostics.loadError': 'Diagnostics could not be loaded.',
  'admin.diagnostics.filter': 'Filter diagnostics',
  'admin.diagnostics.messageRoute': 'Message or route',
  'admin.diagnostics.level': 'Level',
  'admin.diagnostics.allLevels': 'All levels',
  'admin.diagnostics.error': 'Error',
  'admin.diagnostics.warning': 'Warning',
  'admin.diagnostics.source': 'Source',
  'admin.diagnostics.allSources': 'All sources',
  'admin.diagnostics.console': 'Console',
  'admin.diagnostics.vue': 'Vue',
  'admin.diagnostics.router': 'Router',
  'admin.diagnostics.window': 'Window',
  'admin.diagnostics.database': 'Database',
  'admin.diagnostics.from': 'From',
  'admin.diagnostics.to': 'To',
  'admin.diagnostics.applyFilters': 'Apply filters',
  'admin.diagnostics.loading': 'Loading diagnostics…',
  'admin.diagnostics.empty': 'No diagnostics match these filters.',
  'admin.diagnostics.selectPage': 'Select page',
  'admin.diagnostics.selected': '{count} selected',
  'admin.diagnostics.copySelected': 'Copy selected',
  'admin.diagnostics.clear': 'Clear',
  'admin.diagnostics.selectOne': 'Select diagnostic: {message}',
  'admin.diagnostics.copyOne': 'Copy diagnostic: {message}',
  'admin.diagnostics.copy': 'Copy',
  'admin.diagnostics.copiedOne': 'Diagnostic copied',
  'admin.diagnostics.copiedMany': '{count} diagnostics copied',
  'admin.diagnostics.copyError': 'Could not copy. Check browser clipboard permissions.',
  'admin.diagnostics.details': 'Diagnostic details',
  'admin.diagnostics.unknownRoute': 'Unknown route',
  'admin.diagnostics.release': 'Release',
  'admin.diagnostics.environment': 'Environment',
  'admin.diagnostics.fingerprint': 'Fingerprint',
  'admin.diagnostics.user': 'User',
  'admin.diagnostics.pages': 'Diagnostics pages',
  'admin.diagnostics.previous': 'Previous',
  'admin.diagnostics.next': 'Next',
  'admin.diagnostics.page': 'Page {page} of {pages} · {count} reports',
  'admin.diagnostics.reportHeading': 'Diagnostic',
  'admin.diagnostics.reportsHeading': 'Diagnostics ({count})',
  'admin.diagnostics.reported': 'Reported',
  'admin.diagnostics.route': 'Route',
  'admin.diagnostics.id': 'ID',
  'admin.diagnostics.context': 'Context',
  'admin.diagnostics.stack': 'Stack',
  'admin.diagnostics.context.error': 'Error',
  'admin.diagnostics.context.details': 'Details',
  'admin.diagnostics.context.jobId': 'Job ID',
  'admin.diagnostics.context.type': 'Type',
  'admin.diagnostics.context.method': 'Method',
  'admin.diagnostics.context.status': 'Status',
  'admin.diagnostics.context.executionTime': 'Execution time',
  'admin.diagnostics.context.url': 'URL path',
  'admin.diagnostics.context.authCollection': 'Auth collection',
  'admin.diagnostics.context.authId': 'Auth ID',
  'admin.diagnostics.context.referer': 'Referrer path',
  'admin.diagnostics.context.userAgent': 'User agent',
  'admin.pilot.eyebrow': 'Safe release operations',
  'admin.pilot.title': 'Business pilot operations',
  'admin.pilot.description':
    'Test a business feature with a small group of verified businesses before a wider release. Choose participants, control access, monitor results and support issues, then graduate, improve, or stop the pilot.',
  'admin.pilot.authorizationNote': 'Feature flags only limit rollout. They never replace normal business access checks or required Pro entitlements.',
  'admin.pilot.retry': 'Try again',
  'admin.pilot.emptyTitle': 'No business pilots yet',
  'admin.pilot.emptyDescription': 'Create a draft to define the goal, success threshold, participants, and review date before enabling any feature.',
  'admin.pilot.createFirst': 'Create the first pilot',
  'admin.pilot.selectedPilot': 'Pilot workspace',
  'admin.pilot.participants': 'Participants',
  'admin.pilot.enabledFlags': 'Enabled flags',
  'admin.pilot.workspaceSections': 'Business pilot workspace sections',
  'admin.pilot.tab.overview': 'Overview',
  'admin.pilot.tab.rollout': 'Participants & rollout',
  'admin.pilot.tab.support': 'Support',
  'admin.pilot.lifecycle': 'Pilot lifecycle',
  'admin.pilot.lifecycleHelp': 'Follow the controlled path from initial setup to a recorded outcome.',
  'admin.pilot.step.setup': 'Set up',
  'admin.pilot.step.rollout': 'Roll out',
  'admin.pilot.step.monitor': 'Monitor',
  'admin.pilot.step.decide': 'Decide',
  'admin.pilot.nextAction': 'Next action',
  'admin.pilot.next.create': 'Create a pilot draft.',
  'admin.pilot.next.addBusiness': 'Add at least one verified business to the pilot.',
  'admin.pilot.next.configureFlag': 'Configure a pilot-scoped feature flag.',
  'admin.pilot.next.start': 'Review the setup, then start the pilot.',
  'admin.pilot.next.resume': 'Review the iteration changes, then resume the pilot.',
  'admin.pilot.next.monitor': 'Monitor product health and support burden until the review date.',
  'admin.pilot.next.complete': 'This pilot has a recorded outcome.',
  'admin.pilot.startRequirements': 'Starting requires at least one verified-business roster entry and one pilot-scoped feature flag.',
  'admin.pilot.shutdownBlocked': 'Disable every enabled flag for this pilot before shutting it down.',
  'admin.pilot.resume': 'Resume',
  'admin.pilot.details': 'Pilot details',
  'admin.pilot.owner': 'Administrator owner',
  'admin.pilot.currentDecisionLabel': 'Recorded decision',
  'admin.pilot.checkoutCompletion': 'Checkout completion',
  'admin.pilot.targetValue': 'Success target {target}%',
  'admin.pilot.healthMetrics': 'All product health metrics',
  'admin.pilot.metric.active_businesses': 'Active pilot businesses',
  'admin.pilot.metric.activated_businesses': 'Activated businesses',
  'admin.pilot.metric.checkout_started': 'Checkouts started',
  'admin.pilot.metric.checkout_completed': 'Checkouts completed',
  'admin.pilot.metric.booking_attempts': 'Booking attempts',
  'admin.pilot.metric.booking_successes': 'Successful bookings',
  'admin.pilot.metric.reconciliation_exceptions': 'Reconciliation exceptions',
  'admin.pilot.metric.open_support_cases': 'Open support cases',
  'admin.pilot.metric.resolved_support_cases': 'Resolved support cases',
  'admin.pilot.metric.retained_businesses': 'Retained businesses',
  'admin.pilot.rosterHelp': 'Only explicitly selected, verified businesses receive pilot access.',
  'admin.pilot.addBusiness': 'Add business',
  'admin.pilot.rosterEmpty': 'No businesses are enrolled',
  'admin.pilot.rosterEmptyHelp': 'Add a verified business before starting this pilot.',
  'admin.pilot.actions': 'Actions',
  'admin.pilot.update': 'Update',
  'admin.pilot.flagHelp': 'Flags define the feature, environment, rollout window, and safe fallback for this pilot.',
  'admin.pilot.configureFlag': 'Configure flag',
  'admin.pilot.flagsEmpty': 'No pilot flags configured',
  'admin.pilot.flagsEmptyHelp': 'Create a disabled flag first, verify its fallback, then enable it when the pilot is ready.',
  'admin.pilot.disabled': 'Disabled',
  'admin.pilot.edit': 'Edit',
  'admin.pilot.globalFlags': 'Global business rollout flags',
  'admin.pilot.globalFlagsHelp':
    'These flags apply outside a specific pilot and are shown separately to avoid implying that they belong to the selected pilot.',
  'admin.pilot.supportScope':
    'This is the platform-wide business support queue. Cases are not tied to the selected pilot unless their business belongs to its roster.',
  'admin.pilot.supportEmpty': 'No business support cases',
  'admin.pilot.supportEmptyHelp': 'New privacy-minimal support cases will appear here.',
  'admin.pilot.stateLabel': 'State',
  'admin.pilot.createHelp': 'Create the operating contract for a controlled test. Access remains disabled until you configure rollout separately.',
  'admin.pilot.keyHelp': 'Lowercase letters, numbers, and underscores only.',
  'admin.pilot.rosterDialogHelp': 'The business must already be verified. Every change requires an audit reason.',
  'admin.pilot.businessSearchLabel': 'Verified business',
  'admin.pilot.businessSearchPlaceholder': 'Search by business name, username, address, or ID',
  'admin.pilot.businessSearchHelp': 'Enter at least two characters, then choose a verified business from the results.',
  'admin.pilot.businessSearching': 'Searching verified businesses',
  'admin.pilot.businessSearchResults': '{count} verified businesses found',
  'admin.pilot.businessSearchEmpty': 'No verified businesses match this search.',
  'admin.pilot.businessSearchError': 'Verified businesses could not be searched.',
  'admin.pilot.selectedBusiness': 'Selected business',
  'admin.pilot.changeBusiness': 'Change',
  'admin.pilot.flagDialogHelp': 'Saving creates a new audited version for this key and environment.',
  'admin.pilot.confirmDecision': 'Confirm pilot action',
  'admin.pilot.decisionNotes': 'Decision notes',
  'admin.pilot.decisionNotesHelp': 'Record the outcome, evidence, and any follow-up obligations for this terminal decision.',
  'admin.pilot.consequence.pending': 'This changes the pilot state without recording a terminal outcome.',
  'admin.pilot.consequence.iterate': 'The pilot will pause while its gaps, thresholds, or rollout are improved.',
  'admin.pilot.consequence.graduate': 'The pilot will end successfully with graduation recorded as its outcome.',
  'admin.pilot.consequence.shutdown': 'The pilot will end with shutdown recorded as its outcome. Existing customer obligations must still be preserved.',
  'admin.pilot.supportPrivacyHelp':
    'Use only the minimum necessary identifiers and summary. Never paste contact details, credentials, tokens, card data, or provider payloads.',
  'admin.pilot.cancel': 'Cancel',
  'admin.pilot.close': 'Close',
  'admin.pilot.save': 'Save changes',
  'admin.pilot.confirm': 'Confirm and audit',
  'admin.pilot.state.draft': 'Draft',
  'admin.pilot.state.active': 'Active',
  'admin.pilot.state.paused': 'Paused',
  'admin.pilot.state.graduated': 'Graduated',
  'admin.pilot.state.shutdown': 'Shut down',
  'admin.pilot.state.invited': 'Invited',
  'admin.pilot.state.exited': 'Exited',
  'admin.pilot.state.development': 'Development',
  'admin.pilot.state.staging': 'Staging',
  'admin.pilot.state.production': 'Production',
  'admin.pilot.state.low': 'Low',
  'admin.pilot.state.normal': 'Normal',
  'admin.pilot.state.high': 'High',
  'admin.pilot.state.urgent': 'Urgent',
  'admin.pilot.state.open': 'Open',
  'admin.pilot.state.investigating': 'Investigating',
  'admin.pilot.state.waiting': 'Waiting',
  'admin.pilot.state.resolved': 'Resolved',
  'admin.pilot.state.closed': 'Closed',
  'admin.pilot.decision.pending': 'Pending',
  'admin.pilot.decision.graduate': 'Graduate',
  'admin.pilot.decision.iterate': 'Iterate',
  'admin.pilot.decision.shutdown': 'Shut down',
  'admin.pilot.loading': 'Loading pilot operations',
  'admin.pilot.operationFailed': 'The pilot operation failed.',
  'admin.pilot.operationSuccess': 'Pilot operation completed and audited.',
  'admin.pilot.create': 'Create pilot',
  'admin.pilot.key': 'Key',
  'admin.pilot.name': 'Name',
  'admin.pilot.rationale': 'Rationale',
  'admin.pilot.reviewDate': 'Review date',
  'admin.pilot.successTarget': 'Checkout success target %',
  'admin.pilot.shutdownBelow': 'Shutdown below %',
  'admin.pilot.createDraft': 'Create draft',
  'admin.pilot.decision': 'Pilot decision',
  'admin.pilot.pilot': 'Pilot',
  'admin.pilot.choose': 'Choose a pilot',
  'admin.pilot.ownerReview': 'Owner {owner} · review {date}',
  'admin.pilot.currentDecision': 'Decision: {decision} {notes}',
  'admin.pilot.start': 'Start',
  'admin.pilot.pause': 'Pause & iterate',
  'admin.pilot.graduate': 'Graduate',
  'admin.pilot.shutdown': 'Shut down',
  'admin.pilot.decisionReason': 'Reason for this audited pilot decision',
  'admin.pilot.decisionReasonHelp': 'Explain why this state change is necessary. The reason is stored in the immutable audit trail.',
  'admin.pilot.recordDecision': 'Record the decision',
  'admin.pilot.flagRollout': 'Feature flag rollout',
  'admin.pilot.flagKey': 'Flag key',
  'admin.pilot.chooseFlag': 'Choose a feature flag',
  'admin.pilot.flagKeyHelp': 'Select a feature from the same catalog used by Platform admin → Feature flags.',
  'admin.pilot.environment': 'Environment',
  'admin.pilot.environmentHelp': 'Choose where this rollout version applies. Production controls the live experience.',
  'admin.pilot.cohort': 'Cohort',
  'admin.pilot.cohortHelp': 'Limit access to this pilot roster, or apply the flag to every otherwise-authorized business.',
  'admin.pilot.verifiedRoster': 'Verified pilot roster',
  'admin.pilot.authorizedBusinesses': 'All authorized businesses',
  'admin.pilot.starts': 'Starts',
  'admin.pilot.startsHelp': 'Optional. Leave empty to make this version eligible immediately.',
  'admin.pilot.ends': 'Ends',
  'admin.pilot.endsHelp': 'Optional. The version expires automatically at this time.',
  'admin.pilot.fallback': 'Fail-safe fallback',
  'admin.pilot.fallbackPlaceholder': 'Disable feature and retain existing obligations',
  'admin.pilot.fallbackHelp': 'Describe the safe operating state and obligations to preserve if the flag is disabled or rolled back.',
  'admin.pilot.rationaleHelp': 'Explain why this rollout version is needed. This reason is stored in the audit history.',
  'admin.pilot.enabled': 'Enabled',
  'admin.pilot.enabledHelp': 'Turn on server evaluation for this version. Leave off while preparing the rollout.',
  'admin.pilot.entitlement': 'Requires entitlement',
  'admin.pilot.entitlementHelp': 'Also require the normal server-derived entitlement. This flag can never grant one.',
  'admin.pilot.pilotHelp': 'Choose which pilot roster determines access to this feature.',
  'admin.pilot.saveVersion': 'Save version',
  'admin.pilot.roster': 'Verified-business roster',
  'admin.pilot.businessId': 'Verified business ID',
  'admin.pilot.status': 'Status',
  'admin.pilot.reason': 'Reason',
  'admin.pilot.updateRoster': 'Update roster',
  'admin.pilot.health': 'Privacy-safe product health',
  'admin.pilot.healthDescription': 'Aggregate counts only, latest 30 days. Review {date}.',
  'admin.pilot.openSupport': 'Open support case',
  'admin.pilot.optionalBusinessId': 'Business ID (optional)',
  'admin.pilot.supportBusinessHelp':
    'Search by name, username, address, or ID. Select the affected verified business only when it is necessary to investigate the case.',
  'admin.pilot.priority': 'Priority',
  'admin.pilot.priorityHelp': 'Use urgent only when normal business operation or customer obligations are at immediate risk.',
  'admin.pilot.category': 'Category',
  'admin.pilot.categoryHelp': 'Use a short operational category, such as booking, payment, access, or reconciliation.',
  'admin.pilot.relatedRecord': 'Related record',
  'admin.pilot.relatedRecordHelp': 'Optionally link one internal record using its opaque ID. Do not paste provider payloads or customer details.',
  'admin.pilot.relatedRecordType': 'Record type',
  'admin.pilot.relatedRecordId': 'Record ID',
  'admin.pilot.opaqueId': 'Opaque ID',
  'admin.pilot.caseSummary': 'Minimal case summary',
  'admin.pilot.caseSummaryHelp': 'Describe the issue and operational impact using only the minimum information needed for support.',
  'admin.pilot.createReference': 'Create opaque reference',
  'admin.pilot.supportQueue': 'Support queue',
  'admin.pilot.reference': 'Reference',
  'admin.pilot.case': 'Case',
  'admin.pilot.state': 'State',
  'admin.pilot.changeState': 'Change support case state',
  'admin.pilot.changeCaseReason': 'Reason for changing this support case',
  'admin.pilot.resolution': 'Resolution summary',
  'admin.pilot.currentFlags': 'Current flag versions',
  'admin.pilot.flag': 'Flag',
  'admin.pilot.window': 'Window',
  'admin.pilot.version': 'Version',
  'admin.pilot.now': 'now',
  'admin.pilot.manualRollback': 'manual rollback',
  'admin.pilot.development': 'Development',
  'admin.pilot.staging': 'Staging',
  'admin.pilot.production': 'Production',
  'admin.pilot.invited': 'Invited',
  'admin.pilot.active': 'Active',
  'admin.pilot.paused': 'Paused',
  'admin.pilot.exited': 'Exited',
  'admin.pilot.low': 'Low',
  'admin.pilot.normal': 'Normal',
  'admin.pilot.high': 'High',
  'admin.pilot.urgent': 'Urgent',
  'admin.pilot.none': 'None',
  'admin.pilot.booking': 'Booking',
  'admin.pilot.payment': 'Payment',
  'admin.pilot.subscription': 'Subscription',
  'admin.pilot.reconciliation': 'Reconciliation',
  'admin.pilot.open': 'Open',
  'admin.pilot.investigating': 'Investigating',
  'admin.pilot.waiting': 'Waiting',
  'admin.pilot.resolved': 'Resolved',
  'admin.pilot.closed': 'Closed',
  'admin.seed.title': 'Seed data',
  'admin.seed.defaultName': 'Oslo demo data',
  'admin.seed.description':
    'Build recognizable Oslo demo data from focused presets. Every generated record belongs to a run so it can be reviewed and removed later.',
  'admin.seed.progress': 'Seed data setup progress',
  'admin.seed.presets': 'Presets',
  'admin.seed.configure': 'Configure',
  'admin.seed.review': 'Review',
  'admin.seed.choosePresets': 'Choose scenario presets',
  'admin.seed.chooseHelp': 'Combine focused scenarios, or choose All in one for the complete demo. At least one preset is required.',
  'admin.seed.chooseRequired': 'Choose at least one preset to continue.',
  'admin.seed.configureRun': 'Configure this run',
  'admin.seed.defaults': 'The defaults create 3 groups and 12 events around central Oslo.',
  'admin.seed.runAndUser': 'Run and primary user',
  'admin.seed.runName': 'Run name',
  'admin.seed.generateUser': 'Generate a user',
  'admin.seed.generateUserHelp': 'Best for an isolated demo.',
  'admin.seed.existingUser': 'Use an existing user',
  'admin.seed.existingUserHelp': 'Make that account the organizer.',
  'admin.seed.generatedEmail': 'Generated email base',
  'admin.seed.optional': '(optional)',
  'admin.seed.generatedEmailHelp': 'Use an inbox that accepts plus addresses for OTP testing, or leave blank for safe non-deliverable addresses.',
  'admin.seed.existingUserId': 'Existing user ID',
  'admin.seed.recordIdPlaceholder': 'PocketBase record ID',
  'admin.seed.contentOverrides': 'Content overrides',
  'admin.seed.resetDefaults': 'Reset to preset defaults',
  'admin.seed.groups': 'Groups',
  'admin.seed.events': 'Events',
  'admin.seed.supportingUsers': 'Supporting users',
  'admin.seed.anchorDate': 'Anchor date',
  'admin.seed.timezone': 'Timezone',
  'admin.seed.location': 'Location',
  'admin.seed.latitude': 'Latitude',
  'admin.seed.longitude': 'Longitude',
  'admin.seed.radius': 'Radius (km)',
  'admin.seed.reviewRun': 'Review the seed run',
  'admin.seed.reviewHelp': 'Nothing is created until you confirm below.',
  'admin.seed.primaryUser': 'Primary user',
  'admin.seed.existingUserValue': 'Existing user {id}',
  'admin.seed.generatedFrom': 'Generated from “{email}”',
  'admin.seed.generatedAutomatically': 'Generated automatically',
  'admin.seed.plannedContent': 'Planned content',
  'admin.seed.plannedContentValue': '{groups} groups · {events} events · {users} supporting users',
  'admin.seed.placeTime': 'Place and time',
  'admin.seed.warning': 'Seed runs create real application records. Use only for test or demo data, and remove the run when it is no longer needed.',
  'admin.seed.back': 'Back',
  'admin.seed.continue': 'Continue',
  'admin.seed.creating': 'Creating…',
  'admin.seed.create': 'Create seed data',
  'admin.seed.created': 'Seed data created.',
  'admin.seed.started': 'Seed run started.',
  'admin.seed.startError': 'Could not start the seed run.',
  'admin.seed.history': 'Run history',
  'admin.seed.loadingRuns': 'Loading seed runs',
  'admin.seed.historyError': 'Run history could not be loaded',
  'admin.seed.noRuns': 'No seed runs yet.',
  'admin.seed.resourcesCount': '{count} resources',
  'admin.seed.generatedUsersCount': '{count} generated users',
  'admin.seed.viewDetails': 'View details',
  'admin.seed.retryCleanup': 'Retry cleanup',
  'admin.seed.removeData': 'Remove data',
  'admin.seed.runDetails': 'Run details',
  'admin.seed.closeDetails': 'Close run details',
  'admin.seed.loadingDetails': 'Loading run details',
  'admin.seed.loadDetailsError': 'Could not load the seed run.',
  'admin.seed.resources': 'Resources',
  'admin.seed.generatedUsers': 'Generated users',
  'admin.seed.email': 'Email',
  'admin.seed.recordId': 'Record ID',
  'admin.seed.generatedResources': 'Generated resources',
  'admin.seed.collection': 'Collection',
  'admin.seed.label': 'Label',
  'admin.seed.retryCleanupTitle': 'Retry seed cleanup?',
  'admin.seed.removeTitle': 'Remove this seed run?',
  'admin.seed.retryCleanupBody': 'Vennevent will retry removing the remaining records from “{name}”.',
  'admin.seed.removeBody': 'All records generated by “{name}” will be deleted. Existing users and unrelated data are not part of this cleanup.',
  'admin.seed.removing': 'Removing…',
  'admin.seed.removeGenerated': 'Remove generated data',
  'admin.seed.cleanupPartial': 'Some generated records could not be removed. Retry cleanup.',
  'admin.seed.removed': 'Seed data removed.',
  'admin.seed.removeError': 'Could not remove the generated records. You can retry safely.',
  'admin.dashboard.title': 'Platform admin',
  'admin.dashboard.description': 'Operations, trust, and account administration',
  'admin.dashboard.viewAs': 'View the site as',
  'admin.dashboard.actualAccount': 'Actual account ({type})',
  'admin.dashboard.personalAccount': 'Personal account',
  'admin.dashboard.businessAccount': 'Business account',
  'admin.dashboard.previewHelp': 'UI preview only; admin permissions stay active.',
  'admin.dashboard.moderation': 'Moderation',
  'admin.dashboard.sections': 'Admin sections',
  'admin.dashboard.loadError': 'Could not load admin data.',
  'admin.dashboard.actionSuccess': 'Administrative action completed.',
  'admin.dashboard.actionError': 'Administrative action failed.',
  'admin.dashboard.reasonRequired': 'A reason of at least three characters is required.',
  'admin.dashboard.tabs.overview': 'Overview',
  'admin.dashboard.tabs.overviewHelp': 'Platform health and totals',
  'admin.dashboard.tabs.configuration': 'Configuration',
  'admin.dashboard.tabs.configurationHelp': 'URLs, providers, and services',
  'admin.dashboard.tabs.features': 'Features',
  'admin.dashboard.tabs.featuresHelp': 'Feature availability',
  'admin.dashboard.tabs.launch': 'Launch funnel',
  'admin.dashboard.tabs.launchHelp': 'Organizer activation',
  'admin.dashboard.tabs.pilot': 'Business pilot',
  'admin.dashboard.tabs.pilotHelp': 'Pilot programme',
  'admin.dashboard.tabs.seed': 'Seed data',
  'admin.dashboard.tabs.seedHelp': 'Test environment setup',
  'admin.dashboard.tabs.venues': 'Venues',
  'admin.dashboard.tabs.venuesHelp': 'Applications and verification',
  'admin.dashboard.tabs.users': 'Users',
  'admin.dashboard.tabs.usersHelp': 'Accounts and roles',
  'admin.dashboard.tabs.content': 'Content',
  'admin.dashboard.tabs.contentHelp': 'Events and groups',
  'admin.dashboard.tabs.audit': 'Audit',
  'admin.dashboard.tabs.auditHelp': 'Administrative history',
  'admin.dashboard.tabs.diagnostics': 'Diagnostics',
  'admin.dashboard.tabs.diagnosticsHelp': 'Browser and database errors',
  'admin.dashboard.tabs.releases': 'Releases',
  'admin.dashboard.tabs.releasesHelp': 'Production change history',
  'admin.dashboard.metrics.users': 'Users',
  'admin.dashboard.metrics.events': 'Events',
  'admin.dashboard.metrics.groups': 'Groups',
  'admin.dashboard.metrics.verifiedVenues': 'Verified venues',
  'admin.dashboard.metrics.pendingVenues': 'Pending venues',
  'admin.dashboard.metrics.openReports': 'Open reports',
  'admin.dashboard.last30Days': 'Last 30 days',
  'admin.dashboard.date': 'Date',
  'admin.dashboard.activationTitle': 'Organizer activation · last {days} days',
  'admin.dashboard.activationHelp': 'First-party, coarse funnel counts. Raw launch events are retained for 180 days.',
  'admin.dashboard.fromPrevious': '{percent}% from previous',
  'admin.dashboard.acquisitionCohorts': 'Acquisition cohorts',
  'admin.dashboard.source': 'Source',
  'admin.dashboard.campaign': 'Campaign',
  'admin.dashboard.organizers': 'Organizers',
  'admin.dashboard.activated': 'Activated',
  'admin.dashboard.retainedGroups': 'Retained groups',
  'admin.dashboard.featureFlags': 'Feature flags',
  'admin.dashboard.featureHelp': 'Changes apply globally. Disabled flags fail closed for every user.',
  'admin.dashboard.enable': 'Enable',
  'admin.dashboard.disable': 'Disable',
  'admin.dashboard.flagConfirm': '{action} {name} globally? This also applies to platform administrators.',
  'admin.dashboard.flagReason': 'Reason to {action} {name}',
  'admin.dashboard.allStatuses': 'All statuses',
  'admin.dashboard.pending': 'Pending',
  'admin.dashboard.approved': 'Approved',
  'admin.dashboard.rejected': 'Rejected',
  'admin.dashboard.allStates': 'All states',
  'admin.dashboard.restricted': 'Restricted',
  'admin.dashboard.business': 'Business',
  'admin.dashboard.address': 'Address',
  'admin.dashboard.category': 'Category',
  'admin.dashboard.proof': 'Proof',
  'admin.dashboard.preview': 'Preview',
  'admin.dashboard.approve': 'Approve',
  'admin.dashboard.reject': 'Reject',
  'admin.dashboard.approvalReason': 'Internal approval reason',
  'admin.dashboard.rejectionReason': 'Applicant-facing rejection notes',
  'admin.dashboard.popupError': 'Allow popups to preview the venue proof.',
  'admin.dashboard.proofError': 'Could not open the venue proof.',
  'admin.dashboard.user': 'User',
  'admin.dashboard.state': 'State',
  'admin.dashboard.role': 'Role',
  'admin.dashboard.venue': 'Venue',
  'admin.dashboard.verified': 'Verified',
  'admin.dashboard.unverified': 'Unverified',
  'admin.dashboard.restore': 'Restore',
  'admin.dashboard.suspend': 'Suspend',
  'admin.dashboard.revokeModerator': 'Revoke moderator',
  'admin.dashboard.makeModerator': 'Make moderator',
  'admin.dashboard.changeEmail': 'Change email',
  'admin.dashboard.resetPassword': 'Reset password',
  'admin.dashboard.revokeVerification': 'Revoke verification',
  'admin.dashboard.restoreVerification': 'Restore verification',
  'admin.dashboard.newEmail': 'New email address',
  'admin.dashboard.confirmEmail': 'Type CHANGE EMAIL to confirm',
  'admin.dashboard.changeEmailReason': 'Reason for changing this email',
  'admin.dashboard.passwordReason': 'Reason for sending a password reset',
  'admin.dashboard.userStatusReason': 'Reason to {action} this account',
  'admin.dashboard.userRoleReason': 'Reason to set role to {role}',
  'admin.dashboard.verificationReason': 'Reason to {action} venue verification',
  'admin.dashboard.owner': 'Owner',
  'admin.dashboard.restrict': 'Restrict',
  'admin.dashboard.contentReason': 'Reason to {action} this {type}',
  'admin.dashboard.when': 'When',
  'admin.dashboard.action': 'Action',
  'admin.dashboard.target': 'Target',
  'admin.dashboard.reason': 'Reason',
  'admin.dashboard.actor': 'Actor',
} as const;
